import { Component, Input, OnInit } from '@angular/core';
import { LanguageService } from 'src/app/@shared/services/language/language.service';
import { ModalService } from 'src/app/@shared/services/modal/modal.service';
import { RATINGS } from 'src/app/modules/route-planner/constants/multi-language.constants';
import { Rating } from 'src/app/modules/route-planner/interfaces/route-planning/rating.interface';

@Component({
    selector: 'app-rating',
    templateUrl: './rating.component.html',
    styleUrls: ['./rating.component.scss'],
    standalone: false
})
export class RatingComponent implements OnInit {
  @Input() rating: Rating;
  ratingsText: string;

  constructor(private readonly languageService: LanguageService) {}

  ngOnInit(): void {
    this.initializeMultiLanguageTexts();
  }

  initializeMultiLanguageTexts() {
    this.languageService.selectedLanguage$.subscribe((language) => {
      this.ratingsText = RATINGS[language.language];
    });
  }
}
